import React ,{useState}from 'react'
import { Modal, Form, Input, Button, Space, App } from 'antd';
import { useDept_addMutation,} from '../../store/ReactWebSiteApi';
import GetDept from '../../cpn/GetDept';
function DeptAdd(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [info, setInfo] = useState();
    const [Open, setOpen] = useState(false) 
    const [addDept] = useDept_addMutation();
    const confirm = () => {
        Modal.info({
          title: '新增部门成功',
          content: (
            <div>
              <p>请到用户模块，修改用户，添加部门操作权限，否则您无法使用新增的部门！</p>
            </div>
          ),
          onOk() {},
        });
      };
    return (
        <>
            <Button 
                style={{ marginLeft: '15px' }} 
                onClick={() => {
                    setOpen(true)                    
                }} 
                type='primary'
            >新增部门</Button>
            <Modal 
                destroyOnClose={true}
                open={Open}
                title="新增部门"
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {                   
                form
                    .validateFields()
                    .then((values) => {
                        addDept({
                            ed_uid:localStorage.getItem('eu_id'),
                            ed_uname:localStorage.getItem('eu_name'),
                            ed_parent_id: info.ed_parent_id,
                            ed_e_id:localStorage.getItem('e_id'),
                            ed_name: info.ed_name,
                        })
                        .then((res) => {
                            if (res.data.Status === 'success') {
                                confirm()
                                setOpen(false) 
                                }
                            if (res.data.Status === 'fail') {
                                message.error('新增部门失败！' + res.data.Message)
                            }
                        });
                        form.resetFields();                         
                    })
                    .catch((info) => {
                        console.log('Validate Failed:', info);
                    });
                }}
            >
                <Form
                    form={form}
                    name="addDept" 
                    labelCol={{span: 5,}}
                    wrapperCol={{span: 19,}}              
                >
                    <GetDept
                        label='上级部门'
                        required
                        getDept={(e) => {
                            setInfo(prevState => ({ ...prevState,ed_parent_id: e}))
                        }}
                        wrapperCol={{span:15}}
                        name='parent'
                    />
                    <Form.Item
                        name="title"
                        label="部门名称"
                        wrapperCol={{span:15}}
                        rules={[
                        {
                            required: true,
                            message: '请填写子部门名称！',
                        },
                        ]}
                    >
                        <Input onChange={(e) => { 
                            setInfo(prevState => ({ ...prevState, ed_name: e.target.value }))}}  
                            autoFocus={true}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default DeptAdd